// DownloadPopup.js — Popup que aparece momentaneamente após o download do PDF
import React from "react";

const DownloadPopup = ({ message, showPopup }) => {
  if (!showPopup) return null;

  return (
    // Fixo no canto inferior direito da tela
    <div
      className="fixed bottom-6 right-6 z-[9999] max-w-xs px-5 py-4 rounded-xl
                 bg-paper text-ink-fixed text-sm font-medium
                 shadow-[0_10px_40px_rgba(0,0,0,0.15)] border-2 border-insigne-orange/30
                 animate-in fade-in slide-in-from-right"
    >
      {message}
    </div>
  );
};

export default DownloadPopup;
